import React from 'react'
import { Link } from 'react-router-dom'

export default function HotelsCustomComponent(props) {
    return (
        <div className="detailLeft__custom">
         
            <p>اجمالي ما تتسعه الغرفة: {props.productDetail.name || 0}</p>
        </div>
    )
}
